import React from 'react';
import styled from "styled-components";

export const NotAuthorized = () => {
  return (
    <NotAuthorizedStyle>NotAuthorized</NotAuthorizedStyle>
  )
}

const NotAuthorizedStyle = styled.div`
    
`;


export default NotAuthorized;